export function clampValue(value: number, min: number, max: number): number {
  if (isNaN(value)) return min;
  return Math.min(max, Math.max(min, value));
}

export function clampHours(value: number, is12h: boolean): number {
  return is12h ? clampValue(value, 1, 12) : clampValue(value, 0, 23);
}

export function clampMinutes(value: number): number {
  return clampValue(value, 0, 59);
}

export function clampSeconds(value: number): number {
  return clampValue(value, 0, 59);
}

export function formatSegment(value: number | undefined | null): string {
  if (value === undefined || value === null) return "";
  return value.toString().padStart(2, "0");
}

export function parseSegmentInput(text: string): number | null {
  const num = parseInt(text, 10);
  return isNaN(num) ? null : num;
}

export interface ParsedTime {
  hours: number;
  minutes: number;
  seconds: number | null;
  period: "am" | "pm" | null;
}

export function parseTimeString(text: string): ParsedTime | null {
  const match = text
    .trim()
    .match(
      /(\d{1,2})\s*:\s*(\d{1,2})(?:\s*:\s*(\d{1,2}))?\s*(?:([ap])\.?m\.?)?/i
    );
  if (!match) return null;
  const hours = parseInt(match[1], 10);
  const minutes = parseInt(match[2], 10);
  if (isNaN(hours) || isNaN(minutes)) return null;
  const seconds = match[3] != null ? parseInt(match[3], 10) : null;
  const period = match[4]
    ? match[4].toLowerCase() === "p"
      ? "pm"
      : "am"
    : null;
  return { hours, minutes, seconds, period };
}
